// Function to detect browser language preference
export const detectBrowserLanguage = () => {
  // Check if user has previously set a language preference
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage) {
    return savedLanguage;
  }

  // Get browser language preferences
  const browserLang = navigator.language || navigator.languages?.[0] || 'en';
  
  // Extract language code (e.g., 'en-US' -> 'en', 'fr-CA' -> 'fr')
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  // Check if browser language is supported
  if (['en', 'fr'].includes(langCode)) {
    return langCode;
  }
  
  // Check for French Canadian or Quebec preferences
  if (browserLang.includes('fr') || browserLang.includes('CA')) {
    return 'fr';
  }
  
  // Default to French for Quebec market
  return 'fr';
};
